/* =============================================================
   AADHAV ACADEMY – STUDENT REPORT SELECTORS
   ============================================================= */

// Base selector with fallback paths to prevent undefined errors
export const selectStudentReportState = (state) =>
  state.admin?.studentReport || state.studentReport || {};

/* ===== DATA SELECTORS ===== */

// Aggregate view list
export const selectStudentsSummary = (state) =>
  selectStudentReportState(state).studentsSummary ?? [];

// Detailed single student view
export const selectSelectedStudentProfile = (state) =>
  selectStudentReportState(state).selectedStudentProfile ?? null;

export const selectSummaryStats = (state) =>
  selectStudentReportState(state).summaryStats ?? null;

export const selectSessions = (state) =>
  selectStudentReportState(state).sessions ?? [];

export const selectHomework = (state) =>
  selectStudentReportState(state).homework ?? [];

/* ===== META & STATUS SELECTORS ===== */

export const selectReportType = (state) =>
  selectStudentReportState(state).reportType ?? null;

export const selectReportLoading = (state) =>
  selectStudentReportState(state).loading ?? false;

export const selectReportError = (state) =>
  selectStudentReportState(state).error ?? null;

/* ===== PAGINATION SELECTORS ===== */

export const selectReportCurrentPage = (state) =>
  selectStudentReportState(state).currentPage ?? 1;

export const selectReportTotalPages = (state) =>
  selectStudentReportState(state).totalPages ?? 1;

export const selectReportTotal = (state) =>
  selectStudentReportState(state).total ?? 0;

export const selectReportLimit = (state) =>
  selectStudentReportState(state).limit ?? 20;

/* ===== DERIVED HELPER SELECTORS ===== */

export const selectIsSingleStudentReport = (state) =>
  selectReportType(state) === "single_student";

export const selectIsSummaryReport = (state) =>
  selectReportType(state) === "all_students_summary";

export const selectPendingHomeworkCount = (state) =>
  selectHomework(state).filter(
    (hw) => String(hw.submission_status).toLowerCase() === "pending"
  ).length;

export const selectCompletedHomeworkCount = (state) =>
  selectHomework(state).filter((hw) => {
    const status = String(hw.submission_status).toLowerCase();
    return status === "submitted" || status === "reviewed";
  }).length;